import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';

export class UserApperanceConfiguration<T extends EMode = EMode.entity> {
  /** Alias: selectedBackgroundImage */
  selectedBackgroundImage?: string;

  __typename?: string;
}

const fields: FieldDefinitions<UserApperanceConfiguration> = {
  selectedBackgroundImage: {
    alias: 'selectedBackgroundImage',
  },
  __typename: {
    alias: '__typename',
  },
};

export const userApperanceConfigurationEntityDefinition: EntitiyDefinition<UserApperanceConfiguration> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'UserApperanceConfiguration',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
